import mixpanel from "mixpanel-browser";
import { OAuthIDP } from "../hooks/useOAuth";
import { userInformation } from "../lib/network";

// Records employee info on login
export const trackLogin = (user: userInformation, agency: String, ssoProvider?: OAuthIDP) => {
  try {
    // Get data from person query

    const fullName = `${user.firstName} ${user.lastName}`;
    const email = user.email;
    const phone = user.phone;

    // Send information to Mixpanel
    mixpanel.identify(user.id);
    mixpanel.alias(fullName, user.id);
    mixpanel.track("Employee Login", {
      site: agency,
      ssoProvider: ssoProvider || "NONE",
    });
    mixpanel.people.increment({
      "# of Logins": 1,
      "GOGOV Points": 1,
    });
    mixpanel.people.set_once("First Login", new Date());
    mixpanel.people.set({
      "$name": fullName,
      "$email": email,
      "$phone": phone,
      "Last Login": new Date(),
      "site": agency,
      "User Type": user.isEmployee ? "Employee" : "Citizen",
      "Title": user.title,
      "Department ID": user.departmentId,
      "Super Admin": String(user.super_admin),
      "GORequest Role": user.crmRole,
      "GOEnforce Role": user.ceRole,
      "GOPermits Role": user.permitsRole,
      "GONotify Role": user.communicationsRole,
    });

    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const trackCitizenLogin = (user: userInformation, agency: String, ssoProvider?: OAuthIDP) => {
  try {
    const { id, firstName, lastName, email, phone, isEmployee } = user;
    const fullName = firstName + " " + lastName;

    mixpanel.identify(id);
    mixpanel.alias(fullName, id);
    mixpanel.track("Citizen Portal Login", {
      site: agency,
      ssoProvider: ssoProvider || "NONE",
    });
    mixpanel.people.set_once("First Login", new Date());
    mixpanel.people.set({
      "$name": fullName,
      "$email": email,
      "$phone": phone,
      "Last Login": new Date(),
      "site": agency,
      "User Type": isEmployee ? "Employee" : "Citizen",
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const trackMobileLogin = (user: userInformation, agency: String, ssoProvider?: OAuthIDP, appName?: String) => {
  try {
    const { id, firstName, lastName, email, phone, isEmployee } = user;
    const fullName = firstName + " " + lastName;

    mixpanel.identify(id);
    mixpanel.alias(fullName, id);
    mixpanel.track("Mobile App Login", {
      "Agency": agency,
      "Mobile App Name": appName,
      "ssoProvider": ssoProvider || "NONE",
    });
    mixpanel.people.set({
      "$name": fullName,
      "$email": email,
      "$phone": phone,
      "Last Login": new Date(),
      "User Type": isEmployee ? "Employee" : "Citizen",
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
